import React from "react";
import { Modal, Input } from "antd";
import "./EditSectionModal.scss";

const EditSectionModal = ({ open, onCancel, onUpdate, section }) => {
  const [title, setTitle] = React.useState(section?.title || "");
  const [order, setOrder] = React.useState(section?.order || 1);
  const [titleError, setTitleError] = React.useState("");
  const [orderError, setOrderError] = React.useState("");

  React.useEffect(() => {
    setTitle(section?.title || "");
    setOrder(section?.order || 1);
    setTitleError("");
    setOrderError("");
  }, [section]);

  const handleOk = () => {
    let hasError = false;
    
    if (!title.trim()) {
      setTitleError("Title is required");
      hasError = true;
    } else {
      setTitleError("");
    }
    
    if (!order || order < 1) {
      setOrderError("Order must be 1 or greater");
      hasError = true;
    } else {
      setOrderError("");
    }
    
    if (!hasError && title && order) {
      onUpdate(section.id, { title, order });
    }
  };

  return (
    <Modal
      title="Edit Section"
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      okText="Update"
      cancelText="Cancel"
      className="edit-section-modal"
    >
      <div className="section-form-container">
        <div className="section-field">
          <label>Title</label>
          <Input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter section title"
            className="custom-input"
          />
          {titleError && <p className="error">{titleError}</p>}
        </div>

        <div className="section-field">
          <label>Order</label>
          <Input
            type="number"
            min={1}
            value={order}
            onChange={(e) => setOrder(Number(e.target.value))}
            className="custom-input"
          />
          {orderError && <p className="error">{orderError}</p>}
        </div>
      </div>
    </Modal>
  );
};

export default EditSectionModal;